export default function aanvragersFormattedForDropdown(aanvragers, onNew = false) {
	return aanvragers.map(aanvrager => {
		if(onNew){
			if (aanvrager.naam && aanvrager.naam !== '') {
			return {label: aanvrager.naam, value: aanvrager.accountId};
			} else {
			return {label: "Nieuwe aanvrager", value: aanvrager.accountId};
		}
		} else 		{
			return {label: aanvrager.naam, value: aanvrager.id};
		}
	});
}